import { css } from 'aphrodite';
import * as React from 'react';
import { baseStyleSheet } from '../../../styles/styles';
import { Dropdown } from '../../Dropdown';
import { Input } from '../../../components-v2/Input';
import { DisclosureIcon } from '../../svgs/icons/DisclosureIcon';
import { styleSheet as dropdownStyles } from '../DropdownComponent/styles';
import { styleSheet } from './styles';

interface IMoneyFilterResult {
	minimum: string;
	maximum: string;
}

export const MoneyFilterDropdown = ({
	initialMinimum,
	initialMaximum,
	onChange,
	fieldName,
	anchorClassName,
}: {
	initialMinimum: string;
	initialMaximum: string;
	onChange: (value: IMoneyFilterResult) => void;
	fieldName: string;
	anchorClassName?: string;
}) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [minimum, setMinimum] = React.useState(initialMinimum);
	const [maximum, setMaximum] = React.useState(initialMaximum);
	const filterValid = !!minimum || !!maximum;

	const dropdownMessage = React.useMemo(() => {
		if (!initialMinimum && !initialMaximum) {
			return fieldName;
		}
		return `$${initialMinimum || '0'}${initialMaximum ? '-' + initialMaximum : '+'}`;
	}, [initialMinimum, initialMaximum, fieldName]);

	const viewResults = () => {
		setIsOpen(false);
		onChange({
			minimum,
			maximum,
		});
	};

	return (
		<Dropdown
			anchor={
				<div className={css(dropdownStyles.dropdownAnchor)}>
					<span>{dropdownMessage}</span>
					<DisclosureIcon className={css(dropdownStyles.dropdownIcon)} />
				</div>
			}
			anchorClassName={anchorClassName}
			className={css(dropdownStyles.dropdownInline, isOpen ? dropdownStyles.dropdownInlineOpen : null)}
			contentClassName={css(dropdownStyles.dropdownMenu)}
			contentPositionY='bottom'
			contentInnerClassName={css(styleSheet.dropdownContentInnerOverrides)}
			isOpen={isOpen}
			onOpenChanged={setIsOpen}
			openOnClick
		>
			<div className={css(styleSheet.amountDropdown)}>
				<div className={css(styleSheet.amountInputs)}>
					<label className={css(styleSheet.textInputContainer)}>
						<span>Minimum</span>
						<div className={css(styleSheet.textInputWrapper)}>
							<Input
								id={`minimum-${fieldName.toLowerCase()}-amount-input`}
								onChange={e => setMinimum(e.target.value)}
								type='number'
								value={minimum}
								styles={[styleSheet.textInput]}
								placeholder='$'
							/>
						</div>
					</label>

					<div className={css(styleSheet.separator)}>
						<span>&nbsp;</span>
						<span>-</span>
					</div>

					<label className={css(styleSheet.textInputContainer)}>
						<span>Maximum</span>
						<div className={css(styleSheet.textInputWrapper)}>
							<Input
								id={`maximum-${fieldName.toLowerCase()}-amount-input`}
								onChange={e => setMaximum(e.target.value)}
								type='number'
								value={maximum}
								styles={[styleSheet.textInput]}
								placeholder='$'
							/>
						</div>
					</label>
				</div>

				<button className={css(baseStyleSheet.ctaButton)} onClick={viewResults} disabled={!filterValid}>
					View Results
				</button>
			</div>
		</Dropdown>
	);
};
